import { Component } from '@angular/core';
import { BRAND } from '../../../../data/brand/brand.data';
import { INFORMATION_TYPES } from '../../../../data/information/information.data';
import { URLS } from '../../../../data/navigation/navigation.data';
import { RoutingService } from '../../../../service/routing/routing.service';

@Component( {
  selector: 'app-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  styleUrls: [ './maintenance-page.component.scss' ]
} )
export class MaintenancePageComponent {

  URLS = URLS;
  BRAND = BRAND;
  INFORMATION_TYPES = INFORMATION_TYPES;

  appHeroContents = [
    { text: 'Under maintenance', level: 1 },
    { text: 'All of our developers and AI agents are working tirelessly to get the engine running.' }
  ];

  // While they wait, point visitors at the good stuff.
  quickLinks = [
    { label: 'Browse Themes', url: URLS.themes },
    { label: 'Browse Tools', url: URLS.tools.tools },
    { label: 'Read the Blog', url: URLS.blog },
  ];

  // Self-contained on purpose. The previous version reached into the shared
  // <app-top-svg> gradients via document.getElementById(...).setAttribute(),
  // which threw a runtime error whenever those elements weren't in the DOM.
  // Dropping that decorative side effect makes the page crash-proof and
  // independent of any surrounding layout.
  constructor( public routingService: RoutingService ) {
  }

  redirect() {
    this.routingService.redirect( URLS.root );
  }
}
